import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconWrap = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2.73322 5.01001C2.33381 5.01001 2.01001 5.33725 2.01001 5.74092C2.01001 6.14459 2.33381 6.47183 2.73322 6.47183H20.5725C20.9719 6.47183 21.2957 6.14459 21.2957 5.74092C21.2957 5.33725 20.9719 5.01001 20.5725 5.01001H2.73322Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.73322 11.3446C2.33381 11.3446 2.01001 11.6718 2.01001 12.0755C2.01001 12.4791 2.33381 12.8064 2.73322 12.8064H18.4029C19.7343 12.8064 20.8136 13.8972 20.8136 15.2428C20.8136 16.5883 19.7343 17.6791 18.4029 17.6791H14.1221L14.816 16.9777C15.0985 16.6923 15.0985 16.2296 14.816 15.9441C14.5336 15.6587 14.0757 15.6587 13.7933 15.9441L11.8647 17.8932C11.5823 18.1787 11.5823 18.6414 11.8647 18.9268L13.7933 20.8759C14.0757 21.1614 14.5336 21.1614 14.816 20.8759C15.0985 20.5905 15.0985 20.1278 14.816 19.8423L14.1221 19.1409H18.4029C20.5331 19.1409 22.26 17.3956 22.26 15.2428C22.26 13.0899 20.5331 11.3446 18.4029 11.3446H2.73322Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.01001 18.41C2.01001 18.0064 2.33381 17.6791 2.73322 17.6791H9.00108C9.4005 17.6791 9.7243 18.0064 9.7243 18.41C9.7243 18.8137 9.4005 19.1409 9.00108 19.1409H2.73322C2.33381 19.1409 2.01001 18.8137 2.01001 18.41Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconWrap as ReactComponent };
